import configureStore from './configureStore';

const { store, history, persistor } = configureStore();

export {
  store,
  history,
  persistor
}
